import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	textArea: 'm-teaser-event__text-area'
};

@createModule('TeaserEvent')
/**
 * TeaserEvent module implementation.
 *
 * @author Sandy Zhao
 */
export class TeaserEvent extends TerrificSpec {
	$ctx: JQuery;
	
	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		this.initHeight();
		$(window).resize(() => this.initHeight());
		
		resolve();
	}

	initHeight(){
		var textAreaHeight = this.$ctx.find(`.${classes.textArea}`).height() + 88;
		this.$ctx.css("min-height",textAreaHeight);
	}

	stop() {}
}
